import { BaseViewStore } from 'core/stores';
import { ApplicationStore } from 'platform/application/stores';
import { action, makeObservable, observable } from 'mobx';
import { sourceOfChange, viewStoreName } from 'common/constants';
import _ from 'lodash';

class SellerWarehouseViewStore extends BaseViewStore {
	seller;
	@observable sellerWarehouses = [];

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.sellerId = modalParams.data.selectedItem ? modalParams.data.selectedItem.id : null;
		this.applicationStore = new ApplicationStore(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		await this.initializeSellerData();
		this.resume();
	};

	initializeSellerData = async () => {
		await this.applicationStore.getApplication(this.sellerId, {
			embed: [
				'sellerOrganizationInfo',
				'sellerWarehouses',
				'sellerWarehouses.warehouse',
				'sellerWarehouses.warehouse.warehouseOrganizationInfo',
			],
		});
		this.seller = this.applicationStore.item;
		this.sellerWarehouses = this.seller.sellerWarehouses;
	};

	@action.bound
	handleOnChange = item => {
		item.isActive = !item.isActive;
	};

	@action.bound
	updateSellerWarehouses = async () => {
		this.suspend();
		try {
			var sellerWarehousesParams = _.map(this.sellerWarehouses, sellerWarehouse => {
				return {
					id: sellerWarehouse.id,
					isActive: sellerWarehouse.isActive,
				};
			});

			await this.applicationStore.updateSellerWarehouses(
				{
					sellerId: this.seller.id,
					sellerWarehouses: sellerWarehousesParams,
				},
				this.modalParams.data.store_path === viewStoreName.sellerListViewStore
					? sourceOfChange.updateSellerWarehousesList
					: sourceOfChange.updateSellerWarehousesEdit
			);
			this.rootStore.notificationStore.success([
				'SELLERWAREHOUSE.UPDATED',
				{ sellerName: this.seller.applicationTitle },
			]);
			this.modalParams.success();
		} catch (err) {
			this.rootStore.notificationStore.error(['SELLERWAREHOUSE.ERROR', { sellerName: this.seller.applicationTitle }]);
		}
		this.resume();
	};
}

export default SellerWarehouseViewStore;



// WEBPACK FOOTER //
// ./src/modules/seller/stores/SellerWarehouseViewStore.js